// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2ASHb","options":"AnswerScale_options__1jrxw","selected":"AnswerScale_selected__2vT7i"};